import { HgSupportedLanguage } from '@smg-real-estate/domus';
import { createI18n, type I18n } from 'vue-i18n';
import { loadLocale } from './i18n-helper';

// Enum und Default Sprache
export const DEFAULT_LANGUAGE = HgSupportedLanguage.DE;
export enum LocaleFileSuffix {
  HG = 'hg',
  IS24 = 'is24',
}

let localeSuffix = LocaleFileSuffix.HG;

const i18n = createI18n({
  legacy: false,
  locale: DEFAULT_LANGUAGE,
  fallbackLocale: DEFAULT_LANGUAGE,
  silentFallbackWarn: true,
  missing: (currentLocale, key) =>
    console.warn(`Missing translations for "${key}" in "${currentLocale}"`),
  messages: {},
});

export function initI18n(translations: any = {}, fileSuffix = LocaleFileSuffix.HG): I18n {
  // Suffix aktualisieren (z.B. `i18n/en-{suffix}.ts`)
  localeSuffix = fileSuffix;
  i18n.global.mergeLocaleMessage(DEFAULT_LANGUAGE, { ...translations });
  return i18n;
}

export async function safeLoadTranslations(locale: HgSupportedLanguage): Promise<void> {
  try {
    const localeLoaded = await loadTranslations(locale);
    i18n.global.mergeLocaleMessage(locale, { ...localeLoaded.default });
  } catch (e) {
    console.error('Could not load locales', e);
  }
}

export async function loadTranslations(locale: HgSupportedLanguage): Promise<any> {
  return await loadLocale(locale, localeSuffix);
}

export async function setLocaleBeforeRouteChange(locale: HgSupportedLanguage): Promise<void> {
  if (!(locale in i18n.global.messages)) {
    await safeLoadTranslations(locale);
  }
}
